// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientDevicesPopup-module__font-s-10___qjeRs {
  font-size: 10px !important;
}

.PatientDevicesPopup-module__font-s-12___Tz6LY {
  font-size: 12px !important;
}

.PatientDevicesPopup-module__font-s-13___v7V52 {
  font-size: 13px !important;
}

.PatientDevicesPopup-module__font-s-14___QMp4Q {
  font-size: 14px !important;
}

.PatientDevicesPopup-module__font-s-15___IFqC7 {
  font-size: 15px !important;
}

.PatientDevicesPopup-module__font-s-16___b12Hb {
  font-size: 16px !important;
}

.PatientDevicesPopup-module__font-s-18___HkMTY {
  font-size: 18px !important;
}

.PatientDevicesPopup-module__font-s-20___q1aMN {
  font-size: 20px !important;
}

.PatientDevicesPopup-module__font-s-22___D2SKT {
  font-size: 22px !important;
}

.PatientDevicesPopup-module__font-s-28____CG6P {
  font-size: 28px !important;
}

.PatientDevicesPopup-module__font-w-400___izkw9 {
  font-weight: 400 !important;
}

.PatientDevicesPopup-module__font-w-500___yBSpO {
  font-weight: 500 !important;
}

.PatientDevicesPopup-module__font-w-600___OADGC {
  font-weight: 600 !important;
}

.PatientDevicesPopup-module__font-w-700___Rb2JI {
  font-weight: 700 !important;
}

.PatientDevicesPopup-module__p-5___GloGN {
  padding: 5px !important;
}

.PatientDevicesPopup-module__p-12___vBDxo {
  padding: 12px !important;
}

.PatientDevicesPopup-module__p-16___icCag {
  padding: 16px !important;
}

.PatientDevicesPopup-module__p-30___la4d6 {
  padding: 30px !important;
}

.PatientDevicesPopup-module__p-b-0___hQsh8 {
  padding-bottom: 0 !important;
}

.PatientDevicesPopup-module__p-b-5___Ka8Vh {
  padding-bottom: 5px !important;
}

.PatientDevicesPopup-module__p-b-10___nNcEd {
  padding-bottom: 10px !important;
}

.PatientDevicesPopup-module__p-b-12___B1JPI {
  padding-bottom: 12px !important;
}

.PatientDevicesPopup-module__p-b-16___t2RsC {
  padding-bottom: 16px !important;
}

.PatientDevicesPopup-module__p-b-18___O1DcB {
  padding-bottom: 18px !important;
}

.PatientDevicesPopup-module__p-b-20___yVztx {
  padding-bottom: 20px !important;
}

.PatientDevicesPopup-module__p-b-25___KkZE0 {
  padding-bottom: 25px !important;
}

.PatientDevicesPopup-module__p-b-30___tU7Kz {
  padding-bottom: 30px !important;
}

.PatientDevicesPopup-module__p-b-50___tN0Zo {
  padding-bottom: 50px !important;
}

.PatientDevicesPopup-module__p-t-0___OF_eJ {
  padding-top: 0 !important;
}

.PatientDevicesPopup-module__p-t-12___yG_ag {
  padding-top: 12px !important;
}

.PatientDevicesPopup-module__p-t-16___Cn_9d {
  padding-top: 16px !important;
}

.PatientDevicesPopup-module__p-t-18___T_Pr2 {
  padding-top: 18px !important;
}

.PatientDevicesPopup-module__p-t-20___kmCUz {
  padding-top: 20px !important;
}

.PatientDevicesPopup-module__p-t-30___Jv0Xh {
  padding-top: 30px !important;
}

.PatientDevicesPopup-module__p-t-40___AYHKv {
  padding-top: 40px !important;
}

.PatientDevicesPopup-module__p-t-50___kTZly {
  padding-top: 50px !important;
}

.PatientDevicesPopup-module__p-l-20___RyXBS {
  padding-left: 20px !important;
}

.PatientDevicesPopup-module__p-l-30___kC4p0 {
  padding-left: 30px !important;
}

.PatientDevicesPopup-module__p-l-40___ldzNx {
  padding-left: 40px !important;
}

.PatientDevicesPopup-module__p-r-16___RbesM {
  padding-right: 16px !important;
}

.PatientDevicesPopup-module__p-r-20___IgCwx {
  padding-right: 20px !important;
}

.PatientDevicesPopup-module__p-r-30___jDti1 {
  padding-right: 30px !important;
}

.PatientDevicesPopup-module__p-r-50___SWip3 {
  padding-right: 50px !important;
}

.PatientDevicesPopup-module__p-r-60___IGVQq {
  padding-right: 60px !important;
}

.PatientDevicesPopup-module__m-b-1___cLhcM {
  margin-bottom: 1px !important;
}

.PatientDevicesPopup-module__m-b-2___cHY6C {
  margin-bottom: 2px !important;
}

.PatientDevicesPopup-module__m-b-6___aAoZm {
  margin-bottom: 6px !important;
}

.PatientDevicesPopup-module__m-b-8___TLbxO {
  margin-bottom: 8px !important;
}

.PatientDevicesPopup-module__m-b-10___S7lDF {
  margin-bottom: 10px !important;
}

.PatientDevicesPopup-module__m-b-14___YuZpq {
  margin-bottom: 14px !important;
}

.PatientDevicesPopup-module__m-b-16___Wt5_U {
  margin-bottom: 16px !important;
}

.PatientDevicesPopup-module__m-b-20___HOR6U {
  margin-bottom: 20px !important;
}

.PatientDevicesPopup-module__m-b-22___EWXF6 {
  margin-bottom: 22px !important;
}

.PatientDevicesPopup-module__m-b-24___paDXd {
  margin-bottom: 24px !important;
}

.PatientDevicesPopup-module__m-b-30___B4hE2 {
  margin-bottom: 30px !important;
}

.PatientDevicesPopup-module__m-b-32___Txnuf {
  margin-bottom: 32px !important;
}

.PatientDevicesPopup-module__m-b-40___qUxL0 {
  margin-bottom: 40px !important;
}

.PatientDevicesPopup-module__m-t-2___y1tAa {
  margin-top: 2px !important;
}

.PatientDevicesPopup-module__m-t-3___L5uvS {
  margin-top: 3px !important;
}

.PatientDevicesPopup-module__m-t-4___R9AWM {
  margin-top: 4px !important;
}

.PatientDevicesPopup-module__m-t-5___Zm6iO {
  margin-top: 5px !important;
}

.PatientDevicesPopup-module__m-t-8___cEssY {
  margin-top: 8px !important;
}

.PatientDevicesPopup-module__m-t-10___FlyYv {
  margin-top: 10px !important;
}

.PatientDevicesPopup-module__m-t-15___DoLkD {
  margin-top: 15px !important;
}

.PatientDevicesPopup-module__m-t-16___qp7bs {
  margin-top: 16px !important;
}

.PatientDevicesPopup-module__m-t-20___atsGZ {
  margin-top: 20px !important;
}

.PatientDevicesPopup-module__m-t-22___TxOiQ {
  margin-top: 22px !important;
}

.PatientDevicesPopup-module__m-t-30___Ghe3n {
  margin-top: 30px !important;
}

.PatientDevicesPopup-module__m-t-32___y6wsA {
  margin-top: 32px !important;
}

.PatientDevicesPopup-module__m-l-auto___IXE42 {
  margin-left: auto !important;
}

.PatientDevicesPopup-module__m-l-4___CLL4U {
  margin-left: 4px !important;
}

.PatientDevicesPopup-module__m-l-5___F9iSm {
  margin-left: 5px !important;
}

.PatientDevicesPopup-module__m-l-6___c16NX {
  margin-left: 6px !important;
}

.PatientDevicesPopup-module__m-l-8___LqjdG {
  margin-left: 8px !important;
}

.PatientDevicesPopup-module__m-l-10___oVSwP {
  margin-left: 10px !important;
}

.PatientDevicesPopup-module__m-l-16___i4yEZ {
  margin-left: 16px !important;
}

.PatientDevicesPopup-module__m-l-20___lfyIJ {
  margin-left: 20px !important;
}

.PatientDevicesPopup-module__m-l-24___M0mip {
  margin-left: 24px !important;
}

.PatientDevicesPopup-module__m-l-30___qbTLj {
  margin-left: 30px !important;
}

.PatientDevicesPopup-module__m-l-35___LGRjs {
  margin-left: 35px !important;
}

.PatientDevicesPopup-module__m-l-40___Qs5Px {
  margin-left: 40px !important;
}

.PatientDevicesPopup-module__m-r-8___c4Kw7 {
  margin-right: 8px !important;
}

.PatientDevicesPopup-module__m-r-10___wpTyo {
  margin-right: 10px !important;
}

.PatientDevicesPopup-module__m-r-16___GLn1d {
  margin-right: 16px !important;
}

.PatientDevicesPopup-module__m-r-20___yqfAW {
  margin-right: 20px !important;
}

.PatientDevicesPopup-module__m-r-24___oYUzn {
  margin-right: 24px !important;
}

.PatientDevicesPopup-module__m-r-30___kv58l {
  margin-right: 30px !important;
}

.PatientDevicesPopup-module__m-r-40___MJkgE {
  margin-right: 40px !important;
}

.PatientDevicesPopup-module__border-r-3___owu3s {
  border-radius: 3px !important;
}

.PatientDevicesPopup-module__border-r-4___XgV7k {
  border-radius: 4px !important;
}

.PatientDevicesPopup-module__border-r-6___E1bcX {
  border-radius: 6px !important;
}

.PatientDevicesPopup-module__border-r-10___p616M {
  border-radius: 10px !important;
}

.PatientDevicesPopup-module__border-r-12___XZs18 {
  border-radius: 12px !important;
}

.PatientDevicesPopup-module__border-r-16___Lf3Zk {
  border-radius: 16px !important;
}

.PatientDevicesPopup-module__border-r-50___dDy1M {
  border-radius: 50% !important;
}

.PatientDevicesPopup-module__primary-border___LVvXC {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDevicesPopup-module__primary-border-b___iDyJq {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDevicesPopup-module__primary-border-t___wlrfI {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDevicesPopup-module__primary-border-l___Sw76F {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDevicesPopup-module__primary-border-r___T2nob {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDevicesPopup-module__secondary-border___aPk7F {
  border: 1px solid #637768;
}

.PatientDevicesPopup-module__secondary-border-b___aN3XF {
  border-bottom: 1px solid #637768;
}

.PatientDevicesPopup-module__secondary-border-t___HLeh8 {
  border-top: 1px solid #637768;
}

.PatientDevicesPopup-module__secondary-border-l___YV_oa {
  border-left: 1px solid #637768;
}

.PatientDevicesPopup-module__secondary-border-r___YipF5 {
  border-right: 1px solid #637768;
}

.PatientDevicesPopup-module__gap-0___D9B4w {
  gap: 0 !important;
}

.PatientDevicesPopup-module__gap-2___yv3Zq {
  gap: 2px !important;
}

.PatientDevicesPopup-module__gap-4___mvdn0 {
  gap: 4px !important;
}

.PatientDevicesPopup-module__gap-5___BYMUH {
  gap: 5px !important;
}

.PatientDevicesPopup-module__gap-6___YlwI_ {
  gap: 6px !important;
}

.PatientDevicesPopup-module__gap-8___dcPM1 {
  gap: 8px !important;
}

.PatientDevicesPopup-module__gap-10___IjPIe {
  gap: 10px !important;
}

.PatientDevicesPopup-module__gap-12___igt1R {
  gap: 12px !important;
}

.PatientDevicesPopup-module__gap-14___JBcoB {
  gap: 14px !important;
}

.PatientDevicesPopup-module__gap-16___yGB1T {
  gap: 16px !important;
}

.PatientDevicesPopup-module__gap-18___rBN2v {
  gap: 18px !important;
}

.PatientDevicesPopup-module__gap-20___ZxmRQ {
  gap: 20px !important;
}

.PatientDevicesPopup-module__gap-24____PA_c {
  gap: 24px !important;
}

.PatientDevicesPopup-module__gap-26___hBCOi {
  gap: 26px !important;
}

.PatientDevicesPopup-module__gap-30___BLPQI {
  gap: 30px !important;
}

.PatientDevicesPopup-module__gap-32___ppUTf {
  gap: 32px !important;
}

.PatientDevicesPopup-module__gap-40___jVBZQ {
  gap: 40px !important;
}

.PatientDevicesPopup-module__gap-50___mnOO3 {
  gap: 50px !important;
}

.PatientDevicesPopup-module__flex-1___OGb0c {
  flex: 1;
}

.PatientDevicesPopup-module__flex-none___qfNkb {
  flex: none !important;
}

.PatientDevicesPopup-module__flex-column___nxghH {
  display: flex;
  flex-direction: column !important;
}

.PatientDevicesPopup-module__flex-row___Bx8ih {
  display: flex;
  flex-direction: row !important;
}

.PatientDevicesPopup-module__vertically-centered___Ietf6 {
  display: flex;
  align-items: center !important;
}

.PatientDevicesPopup-module__horizontally-centered___OMVAN {
  display: flex;
  justify-content: center !important;
}

.PatientDevicesPopup-module__horizontally-end___RFvPW {
  display: flex;
  justify-content: end !important;
}

.PatientDevicesPopup-module__vertically-start___dG5Nb {
  display: flex;
  align-items: start !important;
}

.PatientDevicesPopup-module__space-between___Bjopz {
  display: flex;
  justify-content: space-between !important;
}

.PatientDevicesPopup-module__flex-wrap___xJBh2 {
  flex-wrap: wrap !important;
}

.PatientDevicesPopup-module__height-100___OnVhD {
  height: 100%;
}

.PatientDevicesPopup-module__width-50___W8guN {
  width: 50% !important;
}

.PatientDevicesPopup-module__width-100___I4jHm {
  width: 100%;
}

.PatientDevicesPopup-module__cursor-pointer___mFEyd {
  cursor: pointer;
}

.PatientDevicesPopup-module__cursor-not-allowed___qIfLG {
  cursor: not-allowed !important;
}

.PatientDevicesPopup-module__absolute-centered___tiSnZ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientDevicesPopup-module__absolute___qbort {
  position: absolute;
}

.PatientDevicesPopup-module__relative___NEmto {
  position: relative;
}

.PatientDevicesPopup-module__fixed___SjZWu {
  position: fixed;
}

.PatientDevicesPopup-module__visible___YFSME {
  opacity: 1;
}

.PatientDevicesPopup-module__invisible___o89s2 {
  opacity: 0;
}

.PatientDevicesPopup-module__col-90___iXlBi {
  width: 90% !important;
}

.PatientDevicesPopup-module__col-auto___YZlTK {
  width: auto !important;
}

.PatientDevicesPopup-module__medical-tabs___ixGWr {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientDevicesPopup-module__medical-table-new___tZTTz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz::-webkit-scrollbar-track {
  display: none;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz.PatientDevicesPopup-module__no-pagination___wJ79a {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz.PatientDevicesPopup-module__no-pagination___wJ79a:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz.PatientDevicesPopup-module__no-pagination___wJ79a::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDevicesPopup-module__medical-table-new___tZTTz.PatientDevicesPopup-module__no-pagination___wJ79a::-webkit-scrollbar-track {
  display: none;
}

.PatientDevicesPopup-module__medical-table-empty___MzGeq {
  padding: 14px 40px !important;
}

.PatientDevicesPopup-module__icon-btn___Ivayd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientDevicesPopup-module__search-icon___TxDr9 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientDevicesPopup-module__disable-select___jrQoD {
  user-select: none;
}

.PatientDevicesPopup-module__break-word___WaXts {
  word-break: break-word;
}

.PatientDevicesPopup-module__popup-clear-btn___DkyTA {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientDevicesPopup-module__scroll-m-b-20___YtH8V {
  scroll-margin-bottom: 20px;
}

.PatientDevicesPopup-module__grid___ffjuZ {
  color: #375844;
  row-gap: 8px;
  column-gap: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.PatientDevicesPopup-module__button___eshup {
  padding: 5px 18px;
  font-size: 12px !important;
  color: white;
  background-color: rgba(240, 31, 81, 0.6980392157);
  max-width: 120px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/PatientDevicesPopup/PatientDevicesPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,iDAAA;EACA,gBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  color: get-color(greenNew, dark);\n  row-gap: 8px;\n  column-gap: 50px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.button {\n  padding: 5px 18px;\n  font-size: 12px !important;\n  color: white;\n  background-color: #f01f51b2;\n  max-width: 120px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientDevicesPopup-module__font-s-10___qjeRs`,
	"fontS12": `PatientDevicesPopup-module__font-s-12___Tz6LY`,
	"fontS13": `PatientDevicesPopup-module__font-s-13___v7V52`,
	"fontS14": `PatientDevicesPopup-module__font-s-14___QMp4Q`,
	"fontS15": `PatientDevicesPopup-module__font-s-15___IFqC7`,
	"fontS16": `PatientDevicesPopup-module__font-s-16___b12Hb`,
	"fontS18": `PatientDevicesPopup-module__font-s-18___HkMTY`,
	"fontS20": `PatientDevicesPopup-module__font-s-20___q1aMN`,
	"fontS22": `PatientDevicesPopup-module__font-s-22___D2SKT`,
	"fontS28": `PatientDevicesPopup-module__font-s-28____CG6P`,
	"fontW400": `PatientDevicesPopup-module__font-w-400___izkw9`,
	"fontW500": `PatientDevicesPopup-module__font-w-500___yBSpO`,
	"fontW600": `PatientDevicesPopup-module__font-w-600___OADGC`,
	"fontW700": `PatientDevicesPopup-module__font-w-700___Rb2JI`,
	"p5": `PatientDevicesPopup-module__p-5___GloGN`,
	"p12": `PatientDevicesPopup-module__p-12___vBDxo`,
	"p16": `PatientDevicesPopup-module__p-16___icCag`,
	"p30": `PatientDevicesPopup-module__p-30___la4d6`,
	"pB0": `PatientDevicesPopup-module__p-b-0___hQsh8`,
	"pB5": `PatientDevicesPopup-module__p-b-5___Ka8Vh`,
	"pB10": `PatientDevicesPopup-module__p-b-10___nNcEd`,
	"pB12": `PatientDevicesPopup-module__p-b-12___B1JPI`,
	"pB16": `PatientDevicesPopup-module__p-b-16___t2RsC`,
	"pB18": `PatientDevicesPopup-module__p-b-18___O1DcB`,
	"pB20": `PatientDevicesPopup-module__p-b-20___yVztx`,
	"pB25": `PatientDevicesPopup-module__p-b-25___KkZE0`,
	"pB30": `PatientDevicesPopup-module__p-b-30___tU7Kz`,
	"pB50": `PatientDevicesPopup-module__p-b-50___tN0Zo`,
	"pT0": `PatientDevicesPopup-module__p-t-0___OF_eJ`,
	"pT12": `PatientDevicesPopup-module__p-t-12___yG_ag`,
	"pT16": `PatientDevicesPopup-module__p-t-16___Cn_9d`,
	"pT18": `PatientDevicesPopup-module__p-t-18___T_Pr2`,
	"pT20": `PatientDevicesPopup-module__p-t-20___kmCUz`,
	"pT30": `PatientDevicesPopup-module__p-t-30___Jv0Xh`,
	"pT40": `PatientDevicesPopup-module__p-t-40___AYHKv`,
	"pT50": `PatientDevicesPopup-module__p-t-50___kTZly`,
	"pL20": `PatientDevicesPopup-module__p-l-20___RyXBS`,
	"pL30": `PatientDevicesPopup-module__p-l-30___kC4p0`,
	"pL40": `PatientDevicesPopup-module__p-l-40___ldzNx`,
	"pR16": `PatientDevicesPopup-module__p-r-16___RbesM`,
	"pR20": `PatientDevicesPopup-module__p-r-20___IgCwx`,
	"pR30": `PatientDevicesPopup-module__p-r-30___jDti1`,
	"pR50": `PatientDevicesPopup-module__p-r-50___SWip3`,
	"pR60": `PatientDevicesPopup-module__p-r-60___IGVQq`,
	"mB1": `PatientDevicesPopup-module__m-b-1___cLhcM`,
	"mB2": `PatientDevicesPopup-module__m-b-2___cHY6C`,
	"mB6": `PatientDevicesPopup-module__m-b-6___aAoZm`,
	"mB8": `PatientDevicesPopup-module__m-b-8___TLbxO`,
	"mB10": `PatientDevicesPopup-module__m-b-10___S7lDF`,
	"mB14": `PatientDevicesPopup-module__m-b-14___YuZpq`,
	"mB16": `PatientDevicesPopup-module__m-b-16___Wt5_U`,
	"mB20": `PatientDevicesPopup-module__m-b-20___HOR6U`,
	"mB22": `PatientDevicesPopup-module__m-b-22___EWXF6`,
	"mB24": `PatientDevicesPopup-module__m-b-24___paDXd`,
	"mB30": `PatientDevicesPopup-module__m-b-30___B4hE2`,
	"mB32": `PatientDevicesPopup-module__m-b-32___Txnuf`,
	"mB40": `PatientDevicesPopup-module__m-b-40___qUxL0`,
	"mT2": `PatientDevicesPopup-module__m-t-2___y1tAa`,
	"mT3": `PatientDevicesPopup-module__m-t-3___L5uvS`,
	"mT4": `PatientDevicesPopup-module__m-t-4___R9AWM`,
	"mT5": `PatientDevicesPopup-module__m-t-5___Zm6iO`,
	"mT8": `PatientDevicesPopup-module__m-t-8___cEssY`,
	"mT10": `PatientDevicesPopup-module__m-t-10___FlyYv`,
	"mT15": `PatientDevicesPopup-module__m-t-15___DoLkD`,
	"mT16": `PatientDevicesPopup-module__m-t-16___qp7bs`,
	"mT20": `PatientDevicesPopup-module__m-t-20___atsGZ`,
	"mT22": `PatientDevicesPopup-module__m-t-22___TxOiQ`,
	"mT30": `PatientDevicesPopup-module__m-t-30___Ghe3n`,
	"mT32": `PatientDevicesPopup-module__m-t-32___y6wsA`,
	"mLAuto": `PatientDevicesPopup-module__m-l-auto___IXE42`,
	"mL4": `PatientDevicesPopup-module__m-l-4___CLL4U`,
	"mL5": `PatientDevicesPopup-module__m-l-5___F9iSm`,
	"mL6": `PatientDevicesPopup-module__m-l-6___c16NX`,
	"mL8": `PatientDevicesPopup-module__m-l-8___LqjdG`,
	"mL10": `PatientDevicesPopup-module__m-l-10___oVSwP`,
	"mL16": `PatientDevicesPopup-module__m-l-16___i4yEZ`,
	"mL20": `PatientDevicesPopup-module__m-l-20___lfyIJ`,
	"mL24": `PatientDevicesPopup-module__m-l-24___M0mip`,
	"mL30": `PatientDevicesPopup-module__m-l-30___qbTLj`,
	"mL35": `PatientDevicesPopup-module__m-l-35___LGRjs`,
	"mL40": `PatientDevicesPopup-module__m-l-40___Qs5Px`,
	"mR8": `PatientDevicesPopup-module__m-r-8___c4Kw7`,
	"mR10": `PatientDevicesPopup-module__m-r-10___wpTyo`,
	"mR16": `PatientDevicesPopup-module__m-r-16___GLn1d`,
	"mR20": `PatientDevicesPopup-module__m-r-20___yqfAW`,
	"mR24": `PatientDevicesPopup-module__m-r-24___oYUzn`,
	"mR30": `PatientDevicesPopup-module__m-r-30___kv58l`,
	"mR40": `PatientDevicesPopup-module__m-r-40___MJkgE`,
	"borderR3": `PatientDevicesPopup-module__border-r-3___owu3s`,
	"borderR4": `PatientDevicesPopup-module__border-r-4___XgV7k`,
	"borderR6": `PatientDevicesPopup-module__border-r-6___E1bcX`,
	"borderR10": `PatientDevicesPopup-module__border-r-10___p616M`,
	"borderR12": `PatientDevicesPopup-module__border-r-12___XZs18`,
	"borderR16": `PatientDevicesPopup-module__border-r-16___Lf3Zk`,
	"borderR50": `PatientDevicesPopup-module__border-r-50___dDy1M`,
	"primaryBorder": `PatientDevicesPopup-module__primary-border___LVvXC`,
	"primaryBorderB": `PatientDevicesPopup-module__primary-border-b___iDyJq`,
	"primaryBorderT": `PatientDevicesPopup-module__primary-border-t___wlrfI`,
	"primaryBorderL": `PatientDevicesPopup-module__primary-border-l___Sw76F`,
	"primaryBorderR": `PatientDevicesPopup-module__primary-border-r___T2nob`,
	"secondaryBorder": `PatientDevicesPopup-module__secondary-border___aPk7F`,
	"secondaryBorderB": `PatientDevicesPopup-module__secondary-border-b___aN3XF`,
	"secondaryBorderT": `PatientDevicesPopup-module__secondary-border-t___HLeh8`,
	"secondaryBorderL": `PatientDevicesPopup-module__secondary-border-l___YV_oa`,
	"secondaryBorderR": `PatientDevicesPopup-module__secondary-border-r___YipF5`,
	"gap0": `PatientDevicesPopup-module__gap-0___D9B4w`,
	"gap2": `PatientDevicesPopup-module__gap-2___yv3Zq`,
	"gap4": `PatientDevicesPopup-module__gap-4___mvdn0`,
	"gap5": `PatientDevicesPopup-module__gap-5___BYMUH`,
	"gap6": `PatientDevicesPopup-module__gap-6___YlwI_`,
	"gap8": `PatientDevicesPopup-module__gap-8___dcPM1`,
	"gap10": `PatientDevicesPopup-module__gap-10___IjPIe`,
	"gap12": `PatientDevicesPopup-module__gap-12___igt1R`,
	"gap14": `PatientDevicesPopup-module__gap-14___JBcoB`,
	"gap16": `PatientDevicesPopup-module__gap-16___yGB1T`,
	"gap18": `PatientDevicesPopup-module__gap-18___rBN2v`,
	"gap20": `PatientDevicesPopup-module__gap-20___ZxmRQ`,
	"gap24": `PatientDevicesPopup-module__gap-24____PA_c`,
	"gap26": `PatientDevicesPopup-module__gap-26___hBCOi`,
	"gap30": `PatientDevicesPopup-module__gap-30___BLPQI`,
	"gap32": `PatientDevicesPopup-module__gap-32___ppUTf`,
	"gap40": `PatientDevicesPopup-module__gap-40___jVBZQ`,
	"gap50": `PatientDevicesPopup-module__gap-50___mnOO3`,
	"flex1": `PatientDevicesPopup-module__flex-1___OGb0c`,
	"flexNone": `PatientDevicesPopup-module__flex-none___qfNkb`,
	"flexColumn": `PatientDevicesPopup-module__flex-column___nxghH`,
	"flexRow": `PatientDevicesPopup-module__flex-row___Bx8ih`,
	"verticallyCentered": `PatientDevicesPopup-module__vertically-centered___Ietf6`,
	"horizontallyCentered": `PatientDevicesPopup-module__horizontally-centered___OMVAN`,
	"horizontallyEnd": `PatientDevicesPopup-module__horizontally-end___RFvPW`,
	"verticallyStart": `PatientDevicesPopup-module__vertically-start___dG5Nb`,
	"spaceBetween": `PatientDevicesPopup-module__space-between___Bjopz`,
	"flexWrap": `PatientDevicesPopup-module__flex-wrap___xJBh2`,
	"height100": `PatientDevicesPopup-module__height-100___OnVhD`,
	"width50": `PatientDevicesPopup-module__width-50___W8guN`,
	"width100": `PatientDevicesPopup-module__width-100___I4jHm`,
	"cursorPointer": `PatientDevicesPopup-module__cursor-pointer___mFEyd`,
	"cursorNotAllowed": `PatientDevicesPopup-module__cursor-not-allowed___qIfLG`,
	"absoluteCentered": `PatientDevicesPopup-module__absolute-centered___tiSnZ`,
	"absolute": `PatientDevicesPopup-module__absolute___qbort`,
	"relative": `PatientDevicesPopup-module__relative___NEmto`,
	"fixed": `PatientDevicesPopup-module__fixed___SjZWu`,
	"visible": `PatientDevicesPopup-module__visible___YFSME`,
	"invisible": `PatientDevicesPopup-module__invisible___o89s2`,
	"col90": `PatientDevicesPopup-module__col-90___iXlBi`,
	"colAuto": `PatientDevicesPopup-module__col-auto___YZlTK`,
	"medicalTabs": `PatientDevicesPopup-module__medical-tabs___ixGWr`,
	"medicalTableNew": `PatientDevicesPopup-module__medical-table-new___tZTTz`,
	"noPagination": `PatientDevicesPopup-module__no-pagination___wJ79a`,
	"medicalTableEmpty": `PatientDevicesPopup-module__medical-table-empty___MzGeq`,
	"iconBtn": `PatientDevicesPopup-module__icon-btn___Ivayd`,
	"searchIcon": `PatientDevicesPopup-module__search-icon___TxDr9`,
	"disableSelect": `PatientDevicesPopup-module__disable-select___jrQoD`,
	"breakWord": `PatientDevicesPopup-module__break-word___WaXts`,
	"popupClearBtn": `PatientDevicesPopup-module__popup-clear-btn___DkyTA`,
	"scrollMB20": `PatientDevicesPopup-module__scroll-m-b-20___YtH8V`,
	"grid": `PatientDevicesPopup-module__grid___ffjuZ`,
	"button": `PatientDevicesPopup-module__button___eshup`
};
module.exports = ___CSS_LOADER_EXPORT___;
